<template>
  <AppHeaderDropdown right no-caret class="vis-app-header-dropdown">
    <template slot="header">
      <vis-acc-dropdown-header
        :presentUser="presentUser"
      ></vis-acc-dropdown-header>
    </template>
    <template slot="dropdown">
      <b-dropdown-header tag="div" class="text-center">
        <strong>{{ $t("Account") }}</strong>
      </b-dropdown-header>
      <b-dropdown-item @click="() => (profileDetailView.visible = true)">
        <i class="far fa-user" />
        {{ $t("Profile") }}
        <vis-detail-view-dialog
          v-if="profileDetailView.crudService !== null"
          :crud-service="profileDetailView.crudService"
          :visible="profileDetailView.visible"
          @hide="() => (profileDetailView.visible = false)"
        />
      </b-dropdown-item>
      <b-dropdown-item @click="openSidebar(sidebarTabs.notifications)">
        <i class="far fa-bell" />
        {{ $t("Updates") }}
      </b-dropdown-item>
      <b-dropdown-item v-if="currentUser.IsEmployee" @click="openSidebar(sidebarTabs.chat)">
        <i class="far fa-envelope" />
        {{ $t("Messages") }}
      </b-dropdown-item>

      <b-dropdown-header tag="div" class="text-center">
        <strong>{{ $t("Settings") }}</strong>
      </b-dropdown-header>
      <!-- <vis-substitute-nav-item @presentUserChanged="onPresentChanged" /> -->
      <b-dropdown-item v-if="!currentUser.isEsia" @click="onChangePassword">
        <i class="far fa-lock" />
        {{ $t("ChangePassword") }}
      </b-dropdown-item>
      <b-dropdown-item @click="openSidebar(sidebarTabs.settings)">
        <i class="far fa-wrench" />
        {{ $t("Settings") }}
      </b-dropdown-item>
      <b-dropdown-divider />
      <b-dropdown-item @click="onLogout">
        <i class="far fa-lock" />
        {{ $t("Logout") }}
      </b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from "@coreui/vue";
import RemoteCrudService from "@/shared/services/remote-crud-service";
import globalState from "../shared/global-state";
import filestorageApi from "@/api/filestorage-api";
import eventBus from "@/shared/global-events";
import { sidebarTabs } from "@/shared/classes";
import { VisGlobalEventTypes } from "@/shared/enum/global-event-types";
// import VisSubstituteNavItem from "@/views/base/user/vis-substitute-nav-item.vue";
import VisAccDropdownHeader from "@/views/base/user/vis-acc-dropdown-header.vue";
import visaryApi from "@/api/visary-api/";

export default {
  name: "vis-header-dropdown-accnt",
  components: {
    AppHeaderDropdown,
    // VisSubstituteNavItem,
    VisAccDropdownHeader
  },
  data: () => {
    return {
      profileDetailView: {
        crudService: null,
        visible: false
      },
      presentUser: null,
      mnemonic: "Profile",
      nickName: null,
      sidebarTabs: sidebarTabs
    };
  },

  computed: {
    currentUser() {
      return globalState.currentUser;
    },
    personCard() {
      return globalState.currentUser && globalState.currentUser.personCard;
    }
  },

  methods: {
    onLogout() {
      this.$visIdentity.navigateToSignOut(this.$router);
    },
    openSidebar(tab) {
      eventBus.emit(VisGlobalEventTypes.TOGGLE_SIDEBAR, {
        force: true,
        activeTab: tab
      });
    },
    onChangePassword() {
      this.$visIdentity.authService.manageRedirect();
    },
    getPresentUserData() {
      visaryApi.substitute.getActiveData();
    },
    async onPresentChanged(id) {
      if (id) {
        let presentData = await visaryApi.substitute.getPresentData(id);
        if (presentData) {
          this.presentUser = {
            nickname: presentData.PresentUserTitle,
            avatar: presentData.PresentUserAvatar
              ? await filestorageApi.preview.getPreviewByLink(
                  presentData.PresentUserAvatar,
                  "s"
                )
              : null
          };
        } else this.presentUser = null;
      } else {
        this.presentUser = null;
      }
    }
  },
  created() {
    this.profileDetailView.crudService = new RemoteCrudService(this.mnemonic);
  },
  async mounted() {
    let user = globalState.currentUser;
    this.profileDetailView.crudService.setId(user.ID);
  }
};
</script>

<style>
.vis-app-header-dropdown > .dropdown-menu {
  width: 11.25rem !important;
}
</style>
